import { useState } from "react";
import { CheckCircle2, Star, Trash2, XCircle } from "lucide-react";

const STATUS_OPTIONS = [
  { value: "new", label: "New", color: "warn" },
  { value: "potential", label: "Potential", color: "good" },
  { value: "converted", label: "Converted", color: "success" },
  { value: "not_converted", label: "Not converted", color: "muted" },
];
const statusMeta = (value) => STATUS_OPTIONS.find((s) => s.value === value) || STATUS_OPTIONS[0];

function LeadRow({ lead, kind, updateStatus, deleteEnquiry }) {
  const meta = statusMeta(lead.status);
  const subtitle = kind === "demo"
    ? `${lead.space_type || "Space TBD"} • ${lead.interest || "Interest TBD"}`
    : `${lead.investor_type || "Type TBD"} · ${lead.ticket_size || "Ticket TBD"} · ${lead.interest || "Interest TBD"}`;
  const mark = (status) => updateStatus(kind, lead.id, status, statusMeta(status).label);
  return (
    <article className={`lead-row status-${meta.color}`} data-testid={`admin-${kind}-row-${lead.id}`}>
      <div className="lead-head">
        <strong>{lead.name}{kind === "investor" && lead.firm ? ` · ${lead.firm}` : ""}</strong>
        <span className={`lead-status-chip chip-${meta.color}`} data-testid={`admin-${kind}-status-${lead.id}`}>{meta.label}</span>
      </div>
      <span>{lead.email}</span>
      <span>{lead.phone || "No phone"}</span>
      <em>{subtitle}</em>
      <p>{lead.message || "No message"}</p>
      <div className="lead-actions" data-testid={`admin-${kind}-actions-${lead.id}`}>
        <button className="status-btn good" onClick={() => mark("potential")} data-testid={`admin-${kind}-mark-potential-${lead.id}`}><Star size={13} /> Potential</button>
        <button className="status-btn success" onClick={() => mark("converted")} data-testid={`admin-${kind}-mark-converted-${lead.id}`}><CheckCircle2 size={13} /> Converted</button>
        <button className="status-btn muted" onClick={() => mark("not_converted")} data-testid={`admin-${kind}-mark-notconverted-${lead.id}`}><XCircle size={13} /> Not converted</button>
        <button className="status-btn delete" onClick={() => deleteEnquiry(kind, lead.id)} data-testid={`admin-${kind}-delete-${lead.id}`}><Trash2 size={13} /> Delete</button>
      </div>
    </article>
  );
}

export function EnquiriesPanel({ demoRequests, investorRequests, updateStatus, deleteEnquiry }) {
  const [tab, setTab] = useState("demo");
  const list = tab === "demo" ? demoRequests : investorRequests;
  return (
    <section className="admin-panel wide enquiry-panel" data-testid="admin-enquiries-panel">
      <div className="enquiry-header">
        <h2>Enquiries</h2>
        <div className="enquiry-tabs" data-testid="admin-enquiry-tabs">
          <button className={`enquiry-tab ${tab === "demo" ? "active" : ""}`} onClick={() => setTab("demo")} data-testid="admin-enquiry-tab-demo">Demo & contact ({demoRequests.length})</button>
          <button className={`enquiry-tab ${tab === "investor" ? "active" : ""}`} onClick={() => setTab("investor")} data-testid="admin-enquiry-tab-investor">Investor ({investorRequests.length})</button>
        </div>
      </div>
      <div className="lead-table" data-testid={`admin-lead-table-${tab}`}>
        {list.map((lead) => <LeadRow key={lead.id} lead={lead} kind={tab} updateStatus={updateStatus} deleteEnquiry={deleteEnquiry} />)}
        {!list.length && <p data-testid={`admin-no-${tab}-message`}>{tab === "demo" ? "No demo or contact requests yet." : "No investor enquiries yet."}</p>}
      </div>
    </section>
  );
}

export function AppStatesPanel({ appStates }) {
  return (
    <section className="admin-panel" data-testid="admin-app-state-panel">
      <h2>Saved VOMARC app states</h2>
      <div className="state-list">
        {appStates.map((state) => (
          <article key={state.id} className="state-row" data-testid={`admin-app-state-row-${state.id}`}>
            <strong>{state.active_tab}</strong><span>{state.selected_product}</span><em>{state.project_progress}% progress</em>
          </article>
        ))}
        {!appStates.length && <p data-testid="admin-no-app-states-message">No saved app states yet.</p>}
      </div>
    </section>
  );
}
